/**
 * Wet eucalypt drought adjustment — used by point_data_vesta_mk2 reducer.
 */

/**
 * Wet drought C1 — spreadsheet S9 uses WRF ($O$10) in polynomial and KBDI ($V$6) as multiplier.
 */
function wetDroughtC1(wrf, kbdi) {
  const poly1 = 0.0046 * Math.pow(wrf, 2) - 0.0079 * wrf - 0.0175;
  const poly2 = -0.9167 * Math.pow(wrf, 2) + 1.5833 * wrf + 13.5;
  return poly1 * kbdi + poly2;
}

/** Wet drought C2 — aspect quartic when aspect in (90, 225] and slope_steepness >= 10. */
function wetDroughtC2(aspect, slopeSteepness) {
  if (aspect < 90 || aspect > 225 || slopeSteepness < 10) {
    return 0;
  }
  return -0.000000002204 * Math.pow(aspect, 4) +
    0.000000995 * Math.pow(aspect, 3) +
    0.00006335 * Math.pow(aspect, 2) -
    0.04895 * aspect + 1.8;
}

export function calculateWetDf(df, wrf, kbdi, aspect, slopeSteepness) {
  const c1 = wetDroughtC1(wrf, kbdi);
  const c2 = wetDroughtC2(aspect, slopeSteepness);
  return df * Math.max(c1 + c2, 0) / 10;
}



// WEBPACK FOOTER //
// ./src/utils/behaviour_models/vesta_mk2/wet.js